import React from 'react'
import { Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom'
import 'antd/dist/reset.css'
import 'App.scss'
import { canAccess, getDefaultRoute, AppRoutePath } from 'config/permissions'
import useAuthStore from 'store/authStore'
import { RefreshAuth } from 'api/Auth'
// page báo cáo kinh doanh
// import Home from 'pages/BusinessReport'
import Home from 'pages/Dashboard'
import Login from 'pages/login'
import Register from 'pages/login/register'
import ForgotPasswordPage from 'pages/login/ForgotPasswordPage'
import Departments from 'pages/departments'
import Chats from 'pages/chats'
import CustomerTags from 'pages/CustomerTags'
import CareStatus from 'pages/CareStatus'
import Profession from 'pages/Profession'
import Customer from 'pages/Customer'
import CustomerDemo from 'pages/CustomerDemo'
import CustomerDemoDetail from 'pages/CustomerDetailsDemo'
import CskhDashboard from 'pages/CskhHub/Dashboard'
import CskhTasks from 'pages/CskhHub/Tasks'
import CskhComplaints from 'pages/CskhHub/Complaints'
import CskhSurveys from 'pages/CskhHub/Surveys'
import MarketingCampaignReport from 'pages/MarketingCampaignReport'
import CustomerDetail from 'pages/CustomerDetails'
import CreateOrder from 'pages/CreateOrder'
import ProductsCat from 'pages/ProductsCat'
import Products from 'pages/Products'
import Warehouses from 'pages/Kho/Stock'
import WarehousesDetail from 'pages/Kho/ItemDetail'
import KhoDashboard from 'pages/Kho/Dashboard'
import KhoItems from 'pages/Kho/Items'
import KhoNorms from 'pages/Kho/Norms'
import KhoDocForm from 'pages/Kho/DocForm'
import KeToanOverview from 'pages/KeToan/Overview'
import KeToanBills from 'pages/KeToan/Bills'
import KeToanReconcile from 'pages/KeToan/Reconcile'
import KeToanInvoices from 'pages/KeToan/Invoices'
import KeToanTaxRates from 'pages/KeToan/TaxRates'
import KeToanTaxReturn from 'pages/KeToan/TaxReturn'
import KeToanBooks from 'pages/KeToan/Books'
import KeToanCards from 'pages/KeToan/Cards'
import KeToanDeposits from 'pages/KeToan/Deposits'
import KeToanRefunds from 'pages/KeToan/Refunds'
import KeToanCommission from 'pages/KeToan/Commission'
import KeToanCounter from 'pages/KeToan/Counter'
import KeToanShiftReview from 'pages/KeToan/ShiftReview'
import KeToanShift from 'pages/KeToan/Shift'
import KeToanSessions from 'pages/KeToan/Sessions'
import Employee from 'pages/Employee'
import GroupRoles from 'pages/Roles/GroupRoles'
import AppointmentTransitions from 'pages/AppointmentTransitions'
import OverviewReport from 'pages/OverviewReport'
import PageReport from 'pages/PageReport'
import OrdersPage from 'pages/OrdersPage'
import ListOrder from 'pages/ListOrder/OrderTableDemo'
import OrderDetailPage from 'pages/ListOrder/OrderDetailPage'
import OrderCustomerDetail from 'pages/OrdersPage/CustomerDetail'
import OrderPageDetail from 'pages/OrdersPage/detail'
import RoomChat from 'pages/RoomChat'
import RealtimeDemo from 'pages/RealtimeDemo'
import QuickMessages from 'pages/QuickMessages'
import SaleOnlineReport from 'pages/SaleOnlineReport'
import BusinessReport from 'pages/BusinessReport'
import CustomerReport from 'pages/CustomerReport'
import HairClinicForm from 'pages/ChuyenMon/HairClinicForm'
import Advertise from 'pages/Advertise/'
import AdsDetail from 'pages/Advertise/AdsDetail'
import MikoReceptionPage from 'pages/ChuyenMon/MikoReceptionPage'
import CosmeticSurgeryReception from 'pages/ChuyenMon/CosmeticSurgeryReception'
import ThreadLiftReception from 'pages/ChuyenMon/ThreadLiftReception'
import ConsultationForm from 'pages/ChuyenMon/ConsultationForm'
import BeautyConsultation from 'pages/ChuyenMon/BeautyConsultation'
import ConsultationTabs from 'pages/ChuyenMon/ConsultationTabs'
import CustomerCM from 'pages/ChuyenMon/Customer'
import CustomerCMDetail from 'pages/ChuyenMon/CustomerDetail'
import CustomerExecution from 'pages/ChuyenMon/CustomerExecution'
import CustomerExecutionDetail from 'pages/ChuyenMon/CustomerExecutionDetail'
import Services from 'pages/Services'
import ServiceList from 'pages/ServiceList'
import BranchManager from 'pages/BranchManager'
import NotificationsPage from 'pages/Notifications'
import UnauthorizedPage from 'pages/Unauthorized'
import NotFoundPage from 'pages/NotFound'
import ProfilePage from 'pages/Admin/profile'
import CareList from 'pages/CareList'
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MarketingReport from 'pages/MarketingReport'
import AdvertisingCampaign from 'pages/AdvertisingCampaign'
import AdvertisingCampaignManagement from 'pages/AdvertisingCampaignManagement'
import DocumentType from 'pages/DocumentType'
import ListOfDocuments from 'pages/ListOfDocuments'
import DocumentManagement from 'pages/DocumentManagement'
import AddNewDocument from 'pages/DocumentManagement/AddNewDocument'
import Request from 'pages/Request'
import RequestAdd from 'pages/Request/Add'
import SubmitForSignature from 'pages/SubmitForSignature'
import AppointmentSurvey from 'pages/AppointmentSurvey'

import Dashboard from 'pages/Dashboard'
import Social from 'pages/Social'
import WorkReport from 'pages/WorkReport'
import WorkList from './pages/WorkList'
import WorkCalender from 'pages/WorkCalender'
import ReportList from 'pages/ReportList'
import ExportInventoryReport from 'pages/Kho/Report'
import InventoryDetail from 'pages/ExportInventoryReport/Detail'
import DebtReport from 'pages/DebtReport'
import DebtDetail from 'pages/DebtReport/Detail'
import DebtContract from 'pages/DebtReport/Contract'
import Revenue from 'pages/Revenue'
import Expense from 'pages/Expense'
import ExpenseDetail from 'pages/Expense/Detail'
import AddExpense from 'pages/Expense/AddExpense'
import Budget from 'pages/Budget'
import Timesheet from 'pages/Hr/TimeSheet'
import TimeDashboard from 'pages/Hr/TimeDashboard'
import TimeRequests from 'pages/Hr/TimeRequests'
import LeaveBalance from 'pages/Hr/LeaveBalance'
import ShiftSetup from 'pages/Hr/ShiftSetup'
import PayAdjust from 'pages/Hr/PayAdjust'
import Payslips from 'pages/Hr/Payslips'
import PaySettings from 'pages/Hr/PaySettings'
import Furlough from 'pages/Timesheet/Furlough'
import DecisionList from 'pages/Decision'
import DecisionDetail from 'pages/Decision/Detail'


import FacebookCallbackStatus from 'pages/chats/FacebookCallbackStatus'
import PersonnelManagement from 'pages/Hr/Employees'
import PersonnelManagementAdd from 'pages/Hr/EmployeeForm'
import PersonnelManagementDetail from 'pages/Hr/EmployeeDetail'
import HrProbation from 'pages/Hr/Probation'
import HrOffboarding from 'pages/Hr/Offboarding'
import HrHeadcountPlan from 'pages/Hr/HeadcountPlan'
import PersonnelManagementDashbroad from 'pages/Hr/Dashboard'
import SubmitForSignatureAdd from 'pages/SubmitForSignature/Add'
import TaskAssignment from 'pages/Hr/Roster'
import Recruitment from 'pages/Hr/RecruitDashboard'
import CandidatesView from 'pages/Hr/Candidates'
import JobsView from 'pages/Hr/Requisitions'
import Interviews from 'pages/Hr/Interviews'
import Offers from 'pages/Hr/Offers'
import TalentPool from 'pages/Hr/TalentPool'
import JobDetailView from 'pages/Hr/RequisitionDetail'
import Assets from 'pages/Assets'
import AssetsSetup from 'pages/Assets/Setup'
import AssetAllocation from 'pages/Assets/AssetAllocation'
import AssetAllocationDetail from 'pages/Assets/AllocationDetail'
import AssetRecall from 'pages/Assets/RecallList'
import AssetRecallDetail from 'pages/Assets/RecallDetail'
import AssetRecallEdit from 'pages/Assets/RecallEdit'
import AssetsList from 'pages/Assets/List'
import AssetDetail from 'pages/Assets/Detail'
import AssetAdd from 'pages/Assets/Add'
import AssetAddAllocation from 'pages/Assets/AddAllocation'
import AssetEdit from 'pages/Assets/Edit'
import AssetAddNewRecall from 'pages/Assets/AddNewRecall'
import ORSchedule from 'pages/ORSchedule'
import OperatingRoom from 'pages/OperatingRoom'
import ImplementationSchedule from 'pages/ImplementationSchedule'
import Assign from 'pages/Assign'
import ContractManagement from 'pages/ContractManagement'
import Supplier from 'pages/Supplier'
import SupplierAdd from 'pages/Supplier/Add'
import SupplierDetail from 'pages/Supplier/Detail'
import SalesContract from 'pages/SalesContract'
import SalesContractDetail from 'pages/SalesContract/Detail'
import SalesContractAdd from 'pages/SalesContract/Add'
import PurchaseOrder from 'pages/PurchaseOrder'
import PurchaseOrderAdd from 'pages/PurchaseOrder/Add'
import PurchaseOrderDetail from 'pages/PurchaseOrder/Detail'
import ImportExport, { CountsPage as KhoCounts } from 'pages/Kho/Docs'
import ImportExportDetail from 'pages/Kho/DocDetail'
import ImportExportCreateInventoryCount from 'pages/Kho/CountForm'
import EmploymentContract from 'pages/Hr/Contracts'
import AddFurlough from 'pages/Timesheet/AddFurlough'
import SalaryList from 'pages/Hr/Payroll'
import SalaryDashboard from 'pages/Salary/Dashboard'
import PersonalDocuments from 'pages/PersonalDocuments'
import PersonalDocumentsDetail from 'pages/PersonalDocuments/Detail'
import Project from 'pages/Project'
import ProjectAdd from 'pages/Project/Add'
import ProjectSetup from 'pages/Project/Setup'
import ProjectDetail from 'pages/Project/Detail'
import TimekeepingReports from 'pages/TimekeepingReports'
import BaoCaoDonXinNghi from 'pages/TimekeepingReports/BaoCaoDonXinNghi'
import BaoCaoDiMuon from 'pages/TimekeepingReports/BaoCaoDiMuon'
import BaoCaoTongHop from 'pages/TimekeepingReports/BaoCaoTongHop'
import DigitalSignature from 'pages/DigitalSignature'
import DigitalSignDetail from 'pages/DigitalSignature/Detail'
import BankList from 'pages/Bank'
import PitDeduction from 'pages/PITdeduction'
import CheckIn from 'pages/CheckIn'
import TienTrinh from 'pages/TienTrinh'
import OrganizationalChart from 'pages/OrganizationalChart'
import WorkProcessPage from 'pages/WorkProcessPage'
import CareerProgression from 'pages/CareerProgression'
import AppTuVan from 'pages/AppTuVan'
import KhachTuVan from 'pages/AppTuVan/KhachTuVan'
import TongQuanTuVan from 'pages/AppTuVan/TongQuan'
import ThanhToanDot from 'pages/AppTuVan/ThanhToanDot'
import PhieuTuVan from 'pages/AppTuVan/PhieuTuVan'
import PhieuBaoGia from 'pages/AppTuVan/PhieuBaoGia'
import CocTaiCoSo from 'pages/AppTuVan/CocTaiCoSo'
import ChuyenThucHien from 'pages/AppTuVan/ChuyenThucHien'
import KetQuaTuVan from 'pages/AppTuVan/KetQuaTuVan'
import BacSiKham from 'pages/AppTuVan/BacSiKham'
import KhaiBao from 'pages/AppTuVan/KhaiBao'
import TongQuanCSKH from 'pages/AppCSKH'
import AppCSKHKhachHang from 'pages/AppCSKH/KhachHang'
import TongDaiCSKH from 'pages/AppCSKH/TongDaiCSKH'
import CongViecCSKH from 'pages/AppCSKH/CongViecCSKH'
import LichChamSoc from 'pages/AppCSKH/LichChamSoc'
import KhieuNaiCSKH from 'pages/AppCSKH/KhieuNai'
import KhaoSatCSKH from 'pages/AppCSKH/KhaoSat'
import BaoCaoCCO from 'pages/BaoCaoCCO'
import DataUser from 'pages/DataUser'

import TiktokCallbackStatus from 'pages/chats/TiktokCallbackStatus'
import TrucPageDashbroad from 'pages/TrucPageDashbroad'
import POS from 'pages/POS'
import PosOrders from 'pages/POS/Orders'
import PosDrafts from 'pages/POS/Drafts'
import PosTransactions from 'pages/POS/Transactions'
import PosRefunds from 'pages/POS/Refunds'
import PosPromotions from 'pages/POS/Promotions'
import PosImport from 'pages/POS/Import'
import PosDashboard from 'pages/POS/Dashboard'
import PosDispatch from 'pages/POS/Dispatch'
import TreatmentDashboard from 'pages/Treatment/Dashboard'
import TreatmentCards from 'pages/Treatment/Cards'
import TreatmentCheckIn from 'pages/Treatment/CheckIn'
import TreatmentDebts from 'pages/Treatment/Debts'
import TreatmentPackages from 'pages/Treatment/Packages'
import DocumentApproval from 'pages/Documents/Approval'
import DocumentDashboard from 'pages/Documents/Dashboard'
import DocumentTrash from 'pages/Documents/Trash'
import ReceptionCheckIn from 'pages/ReceptionCheckIn'
import Telesales from './pages/Test'
import TeleDashboard from 'pages/Telesales'
import TeleSchedule from 'pages/Telesales/SchedulePage'
import TeleCustomers from 'pages/Telesales/Customer'
import TeleCallCenter from 'pages/Telesales/CallCenter'
import TeleReassignHistory from 'pages/Telesales/ReassignHistory'
import TeleDepositReconcile from 'pages/Telesales/DepositReconcile'
import TeleSettings from 'pages/Telesales/Settings'


/**
 * Element của các route được bảo vệ. Key là `AppRoutePath` (khai báo trong
 * `ROUTE_PERMISSIONS`), nên route chưa khai báo quyền sẽ báo lỗi TypeScript.
 */
const ROUTE_ELEMENTS: Record<AppRoutePath, React.ReactElement> = {
  // Quản lý phòng ban
  '/departments': <Departments />,
  // chats: dùng chung màn Chat của Khách tiềm năng (có menu dọc bên trái)
  '/chats': <ChatsRedirect />,
  // Thẻ khách hàng
  '/customer-tags': <CustomerTags />,
  '/appointment-transitions': <AppointmentTransitions />,
  // Chăm sóc khách hàng
  '/care-status': <CareStatus />,
  // Nghề nghiệp
  '/profession': <Profession />,
  // Khách hàng
  '/customer': <Customer />,
  // CRM Khách hàng
  '/customer-demo': <CustomerDemo />,
  // CRM Khách hàng chi tiết
  '/customer-demo/detail': <CustomerDemoDetail />,
  // CSKH: tổng quan, công việc, khiếu nại, khảo sát
  '/cskh-dashboard': <CskhDashboard />,
  '/cskh-tasks': <CskhTasks />,
  '/cskh-complaints': <CskhComplaints />,
  '/cskh-surveys': <CskhSurveys />,
  // CRM Khách hàng chi tiết code
  '/customer/:id': <CustomerDetail />,
  // tạo khách hàng code cũ
  '/appointment/create': <CreateOrder />,
  // Danh mục sản phẩm
  '/products-cat': <ProductsCat />,
  // sản phẩm
  '/products': <Products />,
  // Kho: tổng quan, tồn kho, thẻ kho, danh mục vật tư, định mức dịch vụ, kiểm kho
  '/warehouse-dashboard': <KhoDashboard />,
  '/warehouses': <Warehouses />,
  '/warehouses/detail': <WarehousesDetail />,
  '/warehouse-items': <KhoItems />,
  '/service-norms': <KhoNorms />,
  '/inventory-count': <KhoCounts />,
  // Kế toán (demo đợt 1 của SRS phòng Kế toán)
  '/ke-toan': <KeToanOverview />,
  '/ke-toan/bills': <KeToanBills />,
  '/ke-toan/reconcile': <KeToanReconcile />,
  '/ke-toan/invoices': <KeToanInvoices />,
  '/ke-toan/tax-rates': <KeToanTaxRates />,
  '/ke-toan/tax-return': <KeToanTaxReturn />,
  '/ke-toan/books': <KeToanBooks />,
  '/ke-toan/cards': <KeToanCards />,
  '/ke-toan/deposits': <KeToanDeposits />,
  '/ke-toan/refunds': <KeToanRefunds />,
  '/ke-toan/commission': <KeToanCommission />,
  '/ke-toan/counter': <KeToanCounter />,
  '/ke-toan/counter-bills': <KeToanBills mode="counter" />,
  '/ke-toan/shift-review': <KeToanShiftReview />,
  '/ke-toan/shift': <KeToanShift />,
  '/ke-toan/sessions': <KeToanSessions />,
  // Quản lý nhân sự
  '/employee': <Employee />,
  // Nhóm quyền
  '/group-roles': <GroupRoles />,
  // Báo cáo tổng quan cũ
  '/overview-report': <OverviewReport />,
  // Báo cáo tổng quan 1 cũ
  '/page-report': <PageReport />,
  // Lịch hẹn cũ
  '/appointments': <OrdersPage />,
  // Chi tiết lịch hẹn cũ
  '/appointment/detail/:id': <OrderCustomerDetail />,

  // bắt đầu cũ
  '/appointment/:id': <OrderPageDetail />,
  '/chat/:id': <RoomChat />,
  '/realtime-demo': <RealtimeDemo />,
  '/notifications': <NotificationsPage />,
  '/quick-messages': <QuickMessages />,
  '/hair-clinic': <HairClinicForm />,
  '/advertise': <Advertise />,
  '/advertise/detail': <AdsDetail />,
  '/miko-reception': <MikoReceptionPage />,
  '/cosmetic-surgery-reception': <CosmeticSurgeryReception />,
  '/thread-lift-reception': <ThreadLiftReception />,
  '/consultation-form': <ConsultationForm />,
  '/beauty-consultation': <BeautyConsultation />,
  '/consultation-tabs': <ConsultationTabs />,
  '/sale-online-report': <SaleOnlineReport />,
  '/business-report': <BusinessReport />,
  '/customer-report': <CustomerReport />,
  '/consultations': <CustomerCM />,
  '/consultation/detail/:id': <CustomerCMDetail />,
  '/execution-schedule': <CustomerExecution />,
  '/execution-schedule/detail/:id': <CustomerExecutionDetail />,
  '/services': <Services />,
  '/services-list': <ServiceList />,
  '/branch-manager': <BranchManager />,
  // ket thúc một số page cũ

  // Danh sách bán hàng
  '/list-order': <ListOrder />,
  // Chi tiết đơn hàng
  '/order-detail': <OrderDetailPage />,
  // Danh sách cần chăm sóc
  '/care-list': <CareList />,
  // Báo cáo Marketing
  '/marketing-report': <MarketingReport />,
  // Tài khoản quảng cáo
  '/advertising-campaign': <AdvertisingCampaign />,
  // Báo cáo hiệu suất Marketing
  '/marketing-campaign-report': <MarketingCampaignReport />,
  // Quản lý tiền tố chiến dịch
  '/advertising-campaign-management': <AdvertisingCampaignManagement />,
  // Loại tài liệu
  '/document-type': <DocumentType />,
  // Danh mục tài liệu
  '/list-of-documents': <ListOfDocuments />,
  // quản lý tài liệu
  '/document-management': <DocumentManagement />,
  // Tạo mới tài liệu
  '/add-new-document': <AddNewDocument />,
  // Yêu cầu
  '/request': <Request />,
  // Thêm Yêu cầu
  '/request/add': <RequestAdd />,
  // Quản lý trình ký
  '/submit-for-signature': <SubmitForSignature />,
  // Thông tin cá nhân
  '/admin/profile': <ProfilePage />,
  // Bạn không có quyền truy cập
  '/unauthorized': <UnauthorizedPage />,

  // Hồ sơ nhân sự
  '/personnel-management': <PersonnelManagement />,
  // Thểm nhân sự
  '/personnel-management/add': <PersonnelManagementAdd />,
  // Chi tiết nhân sự
  '/personnel-management/detail': <PersonnelManagementDetail />,
  // Dashboard Nhân sự
  '/personnel-management/dashbroad': <PersonnelManagementDashbroad />,
  // Thử việc, nghỉ việc, định biên
  '/probation': <HrProbation />,
  '/offboarding': <HrOffboarding />,
  '/headcount-plan': <HrHeadcountPlan />,
  // Tạo mới quy trình mẫu
  '/submit-for-signature/add': <SubmitForSignatureAdd />,

  // <Route path='/dashboard' element={<Dashboard />} />
  '/': <Dashboard />,
  // mạng nội bộ
  '/social': <Social />,
  // báo cáo công việc
  '/work-report': <WorkReport />,
  // Quản lý công việc
  '/work-list': <WorkList />,
  // lịch làm việc
  '/work-calender': <WorkCalender />,
  // Danh sách báo cáo
  '/report-list': <ReportList />,
  // Danh sách xuất kho
  '/inventory': <ExportInventoryReport />,
  // xuất kho chi tiết
  '/inventory/detail': <InventoryDetail />,
  // Danh sách nợ xấu
  '/debt': <DebtReport />,
  // Chi tiết nợ xấu
  '/debt-detail/detail': <DebtDetail />,
  // Chi tiết hợp đồng vay nợ
  '/debt-contract/detail': <DebtContract />,
  // doanh thu
  '/revenue': <Revenue />,
  // chi phí
  '/expense': <Expense />,
  // Tạo mới phiếu chi
  '/expense/add': <AddExpense />,
  // chi tiết chi phí
  '/expense-detail/detail': <ExpenseDetail />,
  // ngân sách
  '/budget': <Budget />,
  // Danh sách tài khoản
  '/bank-list': <BankList />,
  // Chấm công
  '/timesheet': <Timesheet />,
  // Check-in (lễ tân)
  '/reception-checkin': <ReceptionCheckIn/>,
  // Hàng chờ + Lịch đặt trước gộp vào trang Check-in (lễ tân); giữ link cũ
  '/reception-queue': <Navigate to="/reception-checkin?tab=queue" replace />,
  '/reception-booking': <Navigate to="/reception-checkin?tab=booked" replace />,
  // Dashboard (telesales)
  '/telesales/dashboard': <TeleDashboard/>,
   // Tổng đài (telesales)
  '/telesales/call-center': <TeleCallCenter/>,
  // Khách hàng (telesales)
  '/telesales/customer': <TeleCustomers/>,
  // Lịch hẹn / Lịch tư vấn (telesales): cùng màn /appointments, /consultations — giữ menu Khách tiềm năng bên trái
  '/telesales/appointments': <OrdersPage />,
  '/telesales/consultations': <CustomerCM />,
  // Chat (telesales): cùng màn /chats — giữ menu Khách tiềm năng bên trái
  '/telesales/chats': <Chats />,
   // Lịch thực hiện (telesales)
  '/telesales/schedule': <TeleSchedule/>,
  // Lịch sử chia lại khách (telesales)
  '/telesales/reassign-history': <TeleReassignHistory/>,
  // Đối soát cọc → ví trả trước (telesales)
  '/telesales/deposits': <TeleDepositReconcile/>,
  '/telesales/settings': <TeleSettings/>,
  
  // Tổng quan chấm công, đơn từ, phép năm, ca làm việc
  '/timekeeping': <TimeDashboard />,
  '/time-requests': <TimeRequests />,
  '/leave-balance': <LeaveBalance />,
  '/shifts': <ShiftSetup />,
  // Bảng phép
  '/furlough': <Furlough />,
  // Tạo mới ngày nghỉ
  '/furlough/add': <AddFurlough />,
  // Tạo mới ứng viên
  '/candidate/add': <CandidatesView openNew />,
  // Chi tiết ứng viên
  '/candidate-detail/detail': <CandidatesView />,
  // Danh sách quyết định
  '/decision': <DecisionList/>,
  // Chi tiết quyết định
  '/decision/detail': <DecisionDetail/>,
  // Bảng lương
  '/salary': <SalaryList />,
  // Tạm ứng, phiếu lương, thiết lập lương
  '/salary-advances': <PayAdjust />,
  '/payslips': <Payslips />,
  '/payroll-settings': <PaySettings />,
  // Tổng quan lương
  '/salary/dashboard': <SalaryDashboard/>,
  // Danh sách ký số
  '/digital-signature': <DigitalSignature/>,
  // Chi tiết ký số
  '/digital-signature/detail': <DigitalSignDetail/>,
  // Thuế TNCN
  '/pit': <PitDeduction/>,
  // Lộ trình thăng tiến
  '/career-progression': <CareerProgression/>,

  // phân công nhiệm vụ
  '/task-assignment': <TaskAssignment />,
  // Tổng quan tuyển dụng
  '/recruitment': <Recruitment />,
  // Danh sách ứng viên
  '/candidates-view': <CandidatesView />,
  // Danh sách tin tuyển dụng
  '/jobs-view': <JobsView />,
  // Lịch phỏng vấn
  '/interviews': <Interviews />,
  // Offer & nhận việc
  '/offers': <Offers />,
  // Kho ứng viên
  '/talent-pool': <TalentPool />,
  // Thêm mới Tin tuyển dụng
  '/job/add': <JobsView openNew />,
  // Chi tiết Tin tuyển dụng
  '/job/detail': <JobDetailView />,
  // Dashboard Tài sản
  '/assets': <Assets />,
  // Cài đặt Tài sản
  '/assets/setup': <AssetsSetup />,
  // Danh sách cấp phát
  '/assets/allocation': <AssetAllocation />,
  // Chi tiết cấp phát
  '/assets/allocation-detail': <AssetAllocationDetail />,
  // Danh sách thu hồi
  '/assets/recall': <AssetRecall />,
  // Chi tiết thu hồi
  '/assets/recall-detail': <AssetRecallDetail />,
  // Sửa thu hồi
  '/assets/recall-edit': <AssetRecallEdit />,
  // Danh sách tài sản
  '/assets/list': <AssetsList />,
  // Chi tiết tài sản
  '/assets/detail': <AssetDetail />,
  // Tạo mới tài sản
  '/assets/add': <AssetAdd />,
  // Tạo mới cấp phát tài sản
  '/assets/allocation-add': <AssetAddAllocation />,
  // Sửa cấp phát tài sản
  '/assets/edit': <AssetEdit />,
  // Thêm mới thu hồi
  '/assets/add-new-recall': <AssetAddNewRecall />,
  // lên lịch mổ
  '/or-schedule': <ORSchedule />,
  // danh sách phòng mổ
  '/operating-room': <OperatingRoom />,
  // lịch trình triển khai
  '/implementation-schedule': <ImplementationSchedule />,
  // Điều Động Ê-kíp & Phân Công
  '/assign': <Assign />,
  // quản lý hợp đồng nhân viên
  '/contract-management': <ContractManagement />,
  // Danh sách nhà cung cấp
  '/supplier': <Supplier />,
  // Thêm nhà cung cấp
  '/supplier/add': <SupplierAdd />,
  // Chi tiết nhà cung cấp
  '/supplier/detail': <SupplierDetail />,
  // Danh sách hợp đồng mua
  '/sales-contract': <SalesContract />,
  // Chi tiết hợp đồng mua
  '/sales-contract/detail': <SalesContractDetail />,
  // Thêm hợp đồng mua
  '/sales-contract/add': <SalesContractAdd />,
  // Danh sách đơn hàng mua
  '/purchase-order': <PurchaseOrder />,
  // Thêm mới đơn hàng mua
  '/purchase-order/add': <PurchaseOrderAdd />,
  // Chi tiết đơn hàng mua
  '/purchase-order/detail': <PurchaseOrderDetail />,
  // Danh sách phiếu xuất kho
  '/import-export': <ImportExport />,
  // Chi tiết phiếu xuất kho
  '/import-export/detail': <ImportExportDetail />,
  // Thêm mới phiếu nhập kho
  '/import-export/add-import': <KhoDocForm mode="import" />,
  // Thêm mới Phiếu xuất
  '/import-export/add-export': <KhoDocForm mode="export" />,
  // Thêm mới phiếu kiểm kho
  '/import-export/create-inventory-count': <ImportExportCreateInventoryCount />,
  // hợp đồng lao động
  '/employment-contract': <EmploymentContract />,
  // chi tiết hợp đồng lao động
  '/employment-contract/detail': <EmploymentContract />,
  // Thêm hợp đồng lao động
  '/employment-contract/add': <EmploymentContract openNew />,
  // tài liệu cá nhân
  '/personal-documents': <PersonalDocuments />,
  // Chi tiết tài liệu cá nhân
  '/personal-documents/detail': <PersonalDocumentsDetail />,
  // Tổng quan tài liệu
  '/document-dashboard': <DocumentDashboard />,
  // Duyệt tài liệu
  '/document-approval': <DocumentApproval />,
  // Thùng rác tài liệu
  '/document-trash': <DocumentTrash />,
  // danh sách dự án
  '/projects': <Project />,
  // Thêm dự án
  '/projects/add': <ProjectAdd />,
  // cài đặt dự án
  '/projects/setup': <ProjectSetup />,
  // Chi tiết dự án
  '/projects/detail': <ProjectDetail />,
  // Danh sách báo cáo chấm công
  '/timekeeping-reports': <TimekeepingReports />,
  // Báo cáo đơn xin nghỉ
  '/timekeeping-reports/bao-cao-don-xin-nghi': <BaoCaoDonXinNghi />,
  // Báo cáo đi muộn
  '/timekeeping-reports/bao-cao-di-muon': <BaoCaoDiMuon />,
  // Báo cáo tổng hợp
  '/timekeeping-reports/bao-cao-tong-hop': <BaoCaoTongHop />,
  // check in
  '/check-in': <CheckIn />,
  // Tien trinh
  '/tien-trinh': <TienTrinh />,
  // Dashboard Truc page
  '/dashbroad-truc-page': <TrucPageDashbroad />,
  // so do to chuc
  '/so-do-to-chuc': <OrganizationalChart />,
  // qua trinh lam viec
  '/work-process-page': <WorkProcessPage />,
  // page pos
  '/pos': <POS />,
  '/pos/orders': <PosOrders />,
  '/pos/drafts': <PosDrafts />,
  '/pos/transactions': <PosTransactions />,
  '/pos/refunds': <PosRefunds />,
  '/pos/promotions': <PosPromotions />,
  '/pos/import': <PosImport />,
  '/pos/dashboard': <PosDashboard />,
  '/pos/dispatch': <PosDispatch />,
  '/treatment': <TreatmentDashboard />,
  '/treatment/cards': <TreatmentCards />,
  '/treatment/checkin': <TreatmentCheckIn />,
  '/treatment/debts': <TreatmentDebts />,
  '/treatment/packages': <TreatmentPackages />,
  //App tu van
  '/app-tuvan': <AppTuVan />,
  '/tong-quan-tu-van': <TongQuanTuVan />,
  '/khach-tu-van': <KhachTuVan />,
  '/thanh-toan-dot': <ThanhToanDot />,
  //Phieu Tu Van
  '/phieu-tu-van': <PhieuTuVan />,
  //Phieu Tu Van
  '/phieu-bao-gia': <PhieuBaoGia />,
  //Bác sĩ khám (bước 2, không thấy tiền)
  '/bac-si-kham': <BacSiKham />,
  //Kế hoạch thanh toán (tên cũ Cọc tại cơ sở — giữ đường dẫn cũ cho liên kết đã gửi)
  '/ke-hoach-thanh-toan': <CocTaiCoSo />,
  '/coc-tai-co-so': <CocTaiCoSo />,
  //Khách khai báo thông tin ban đầu sau check-in
  '/khai-bao': <KhaiBao />,
  //Chuyển thực hiện
  '/chuyen-thuc-hien': <ChuyenThucHien />,
  //Kết quả tư vấn
  '/ket-qua-tu-van': <KetQuaTuVan />,
  //Kết quả tư vấn
  '/tong-quan-cskh': <TongQuanCSKH />,
  '/app-cskh/khach-hang': <AppCSKHKhachHang />,
  '/app-cskh/tong-dai-cskh': <TongDaiCSKH />,
  '/app-cskh/cong-viec-cskh': <CongViecCSKH />,
  '/app-cskh/lich-cham-soc': <LichChamSoc />,
  '/app-cskh/khieu-nai': <KhieuNaiCSKH />,
  '/app-cskh/khao-sat': <KhaoSatCSKH />,
  '/bao-cao-cco': <BaoCaoCCO />,
  '/data-user': <DataUser />,
};

/** Link cũ /chats (Dashboard, thông báo, callback kết nối kênh) chuyển sang /telesales/chats, giữ nguyên query */
function ChatsRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/telesales/chats${search}`} replace />;
}

function PrivateRoute() {
  const token = localStorage.getItem('token');
  return token ? <Outlet /> : <Navigate to="/login" replace />;
}

/**
 * Bảo vệ route dựa trên permissions (data.info.role.permissions).
 * Super admin (type === 1) toàn quyền, bỏ qua check permissions.
 */
function PermissionRoute() {
  const { permissions, isSuperAdmin, type } = useAuthStore();
  const location = useLocation();
  const token = localStorage.getItem('token');

  if (!token) return <Navigate to="/login" replace />;

  // Cho phép vào trang thông báo để tránh vòng lặp redirect.
  if (location.pathname === '/unauthorized') return <Outlet />;

  if (type === null) {
    return <Navigate to="/unauthorized" replace state={{ from: location.pathname }} />;
  }

  if (!canAccess(location.pathname, permissions, isSuperAdmin)) {
    // Không có quyền trang chủ: chuyển tới trang đầu tiên user được vào
    if (location.pathname === '/') {
      const defaultRoute = getDefaultRoute(permissions, isSuperAdmin);
      if (defaultRoute !== '/unauthorized') {
        return <Navigate to={defaultRoute} replace />;
      }
    }
    return <Navigate to="/unauthorized" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
}

const App: React.FC = () => {
  // Đồng bộ lại quyền của nhân viên đang đăng nhập với backend khi:
  //   - App mount (mở tab / F5)
  //   - Tab được focus lại sau khi rời đi
  // Tránh việc admin đổi nhóm quyền nhưng client vẫn dùng cache cũ trong localStorage.
  React.useEffect(() => {
    const sync = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;
      const res = await RefreshAuth();
      if (res.ok) {
        useAuthStore.getState().setAuth(res.type ?? null, res.permissions ?? []);
      }
    };
    sync();
    const onFocus = () => { sync(); };
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, []);

  return (
    <>
      <Routes>
        {/* Public routes */}
        <Route path='/login' element={<Login />} />
        <Route path='/register' element={<Register />} />
        <Route path='/forgot-password' element={<ForgotPasswordPage />} />
        {/* Khách hàng tự đánh giá sau dịch vụ — không yêu cầu đăng nhập */}
        <Route path='/khao-sat/:id' element={<AppointmentSurvey />} />
        {/* Facebook OAuth redirect về đây (FACEBOOK_FRONTEND_CALLBACK_URL) — mở trong popup,
            để ngoài PermissionRoute để không bị đá về /login hay /unauthorized */}
        <Route path='/facebook/callback-status' element={<FacebookCallbackStatus />} />
        {/* TikTok Business OAuth redirect ve day (TIKTOK_FRONTEND_CALLBACK_URL) */}
        <Route path='/tiktok/callback' element={<TiktokCallbackStatus />} />

        {/* Protected routes */}
        <Route element={<PermissionRoute />}>
          {Object.entries(ROUTE_ELEMENTS).map(([path, element]) => (
            <Route key={path} path={path} element={element} />
          ))}
        </Route>

        <Route path='*' element={<NotFoundPage />} />
      </Routes >
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  )
}

export default App
